(function () {
  'use strict';

  var INIT = 'data-lp-affiliate-init';

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function scrollToTarget(root, selector) {
    if (!selector) return;
    var target = document.querySelector(selector);
    if (!target) return;
    target.scrollIntoView({
      behavior: reducedMotion() ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  function initScrollButtons(root) {
    root.querySelectorAll('[data-lp-affiliate-scroll]').forEach(function (btn) {
      if (btn.getAttribute('data-lp-affiliate-scroll-bound') === 'true') return;
      btn.setAttribute('data-lp-affiliate-scroll-bound', 'true');
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        scrollToTarget(root, btn.getAttribute('data-lp-affiliate-scroll'));
      });
    });
  }

  function initReveal(root) {
    var items = root.querySelectorAll('[data-lp-affiliate-reveal]');
    if (!items.length) return;

    if (reducedMotion()) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    items.forEach(function (el) {
      if (el.getAttribute('data-lp-affiliate-reveal-bound') === 'true') return;
      el.setAttribute('data-lp-affiliate-reveal-bound', 'true');
      io.observe(el);
    });
  }

  function initValueCrossfade(root) {
    var section = root.querySelector('[data-lp-affiliate-value]');
    if (!section || section.getAttribute('data-lp-affiliate-value-bound') === 'true') return;
    section.setAttribute('data-lp-affiliate-value-bound', 'true');

    var desktop = section.querySelector('[data-lp-affiliate-value-desktop]');
    if (!desktop || !window.matchMedia('(min-width: 990px)').matches) return;

    var panels = desktop.querySelectorAll('[data-lp-affiliate-value-panel]');
    var images = desktop.querySelectorAll('[data-lp-affiliate-value-image]');
    if (!panels.length || !images.length) return;

    function setActive(index) {
      panels.forEach(function (panel, i) {
        panel.classList.toggle('is-active', i === index);
      });
      images.forEach(function (image, i) {
        image.classList.toggle('is-active', i === index);
      });
    }

    function updateActive() {
      if (!window.matchMedia('(min-width: 990px)').matches) return;

      var targetY = window.innerHeight * 0.42;
      var bestIndex = 0;
      var bestDistance = Infinity;

      panels.forEach(function (panel, index) {
        var rect = panel.getBoundingClientRect();
        var center = rect.top + rect.height * 0.5;
        var distance = Math.abs(center - targetY);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      setActive(bestIndex);
    }

    if (reducedMotion()) {
      setActive(0);
      return;
    }

    section._lpAffValueScroll = updateActive;
    window.addEventListener('scroll', updateActive, { passive: true });
    window.addEventListener('resize', updateActive);
    updateActive();
  }

  function initSteps(root) {
    var section = root.querySelector('[data-lp-affiliate-steps]');
    if (!section || section.getAttribute('data-lp-affiliate-steps-bound') === 'true') return;
    section.setAttribute('data-lp-affiliate-steps-bound', 'true');

    var steps = section.querySelectorAll('[data-lp-affiliate-step]');
    if (!steps.length) return;

    function activateSteps() {
      section.classList.add('is-animated');
      steps.forEach(function (step, index) {
        window.setTimeout(function () {
          step.classList.add('is-active');
        }, index * 90);
      });
    }

    if (reducedMotion()) {
      activateSteps();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          activateSteps();
          io.disconnect();
        });
      },
      { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
    );

    io.observe(section);
  }

  function initFaq(root) {
    var items = root.querySelectorAll('[data-lp-affiliate-faq-item]');
    items.forEach(function (item) {
      if (item.getAttribute('data-lp-affiliate-faq-bound') === 'true') return;
      item.setAttribute('data-lp-affiliate-faq-bound', 'true');

      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      });
    });
  }

  function clearBindings(root) {
    var valueSection = root.querySelector('[data-lp-affiliate-value]');
    if (valueSection && valueSection._lpAffValueScroll) {
      window.removeEventListener('scroll', valueSection._lpAffValueScroll);
      window.removeEventListener('resize', valueSection._lpAffValueScroll);
      valueSection._lpAffValueScroll = null;
    }

    root.removeAttribute(INIT);
    root.querySelectorAll('[data-lp-affiliate-scroll-bound]').forEach(function (el) {
      el.removeAttribute('data-lp-affiliate-scroll-bound');
    });
    root.querySelectorAll('[data-lp-affiliate-reveal-bound]').forEach(function (el) {
      el.removeAttribute('data-lp-affiliate-reveal-bound');
    });
    root.querySelectorAll('[data-lp-affiliate-value-bound]').forEach(function (el) {
      el.removeAttribute('data-lp-affiliate-value-bound');
    });
    root.querySelectorAll('[data-lp-affiliate-steps-bound]').forEach(function (el) {
      el.removeAttribute('data-lp-affiliate-steps-bound');
    });
    root.querySelectorAll('[data-lp-affiliate-faq-bound]').forEach(function (el) {
      el.removeAttribute('data-lp-affiliate-faq-bound');
    });
  }

  function initRoot(root) {
    if (!root || root.getAttribute(INIT) === 'true') return;
    root.setAttribute(INIT, 'true');
    initScrollButtons(root);
    initReveal(root);
    initValueCrossfade(root);
    initSteps(root);
    initFaq(root);
  }

  function boot() {
    document.querySelectorAll('[data-lp-affiliate]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-lp-affiliate]');
    if (root) {
      clearBindings(root);
      initRoot(root);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-lp-affiliate]');
    if (root) clearBindings(root);
  });
})();
